/* global YT */

if (document.getElementsByClassName('js-youtube')[0]) {
  callYoutubeAPI()
}

function callYoutubeAPI() {
  // YouTubeのAPIを呼び出す
  const tag = document.createElement('script')
  tag.src = 'https://www.youtube.com/iframe_api'
  const firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

  // iOSの判別
  const isIOS =
    /[ \(]iP/.test(navigator.userAgent) || // iPhone,iPad,iPodの検出
    (navigator.userAgent.indexOf('Macintosh') > -1 && 'ontouchend' in document) // PC表示モードのiPad（UAがMac+タッチ操作対応環境）の検出

  const movieList = document.getElementsByClassName('js-youtube')
  let movie = []
  window.onYouTubeIframeAPIReady = function () {
    if (isIOS) {
      const movieBtn = document.getElementsByClassName('js-youtube-btn')
      for (const iterator of movieBtn) {
        // サムネイルを消す
        iterator.style.display = 'none'
      }
    }
    for (const movieItem of movieList) {
      if (!isIOS) {
        // iOS以外はサムネイルをクリックしたらiframeを展開して再生開始
        window.addEventListener('click', function (e) {
          if (e.target.dataset.id !== movieItem.id) {
            return false
          }

          youtubeSetup(movieItem)

          // console.log(movie)
          // console.log(movie[e.target.dataset.id])
          // サムネイルを消す
          e.target.parentNode.removeChild(e.target)
        })
      } else {
        // iOSはAPIで再生ができないので最初からiframeを展開する
        youtubeSetup(movieItem)
      }
    }
  }
  function youtubeSetup(movieItem) {
    movie[movieItem.id] = new YT.Player(
      movieItem.id, // プレイヤーに変化させる要素のID
      {
        videoId: movieItem.dataset.youtube, // 動画ID
        width: 1920, // 幅
        height: 1080, // 高さ
        playerVars: {
          playsinline: 1, // インライン再生(iOS環境で制御に必要)
          controls: 1, // コントローラー
          rel: 0, // おすすめ動画
          showinfo: 0, // タイトル
          disablekb: 1, // キーボード操作の禁止
          color: 'white', // シークバーの色（red/white）
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
        },
      }
    )
  }
  function onPlayerReady(e) {
    // 再生準備完了時の処理
    // movie[lastClick.dataset.id].playVideo() // 再生開始
    if (!isIOS) {
      e.target.playVideo() // 再生開始
    }
  }
  function onPlayerStateChange(e) {
    // 動画の状態変化時の処理
    if (e.data === YT.PlayerState.PLAYING) {
      // 再生中
    }
    if (e.data === YT.PlayerState.PAUSED) {
      // 停止
    }
    if (e.data === YT.PlayerState.BUFFERING) {
      // バッファリング中
    }
    if (e.data === YT.PlayerState.CUED) {
      // 頭出し済み
    }
    if (e.data === YT.PlayerState.ENDED) {
      // 再生終了
      // e.target.playVideo() // 再度再生
    }
  }
}
